import type { HTMLAttributes, ReactNode } from 'react';

import { cx } from '../utils/cx';

export type CardProps = HTMLAttributes<HTMLDivElement>;

/** The prototypes' surface container — dashboard panels, checkout summary, product cards. */
export function Card({ className, children, ...rest }: CardProps): ReactNode {
  return (
    <div className={cx('ecom-card', className)} {...rest}>
      {children}
    </div>
  );
}
